import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen gradient-secondary">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="flex items-center mb-8">
          <Link 
            to="/" 
            className="p-2 glass rounded-full hover:bg-white/10 transition-smooth mr-4"
          >
            <ArrowLeft className="w-5 h-5 text-white" />
          </Link>
          <h1 className="text-3xl font-bold gradient-text">Privacy Policy</h1>
        </div>

        <Card className="glass border-white/20 mb-6">
          <CardHeader>
            <CardTitle className="text-white">Data di ultima modifica: 1 Settembre 2025</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-white/90">
            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">1. Introduzione</h2>
              <p className="leading-relaxed">
                La presente Privacy Policy descrive come AstroPet raccoglie, utilizza e protegge i tuoi dati personali 
                in conformità al Regolamento Generale sulla Protezione dei Dati (GDPR) UE 2016/679 e alla normativa italiana.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">2. Titolare del Trattamento</h2>
              <div className="bg-white/5 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Titolare:</strong> AstroPet S.r.l.<br/>
                  <strong>Sede:</strong> [Indirizzo completo]<br/>
                  <strong>Email:</strong> privacy@astropet.com<br/>
                  <strong>PEC:</strong> astropet@pec.it
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">3. Dati Raccolti</h2>
              <h3 className="text-xl font-semibold text-primary mb-3">3.1 Dati forniti direttamente</h3>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Informazioni di registrazione (email, username, password)</li>
                <li>Dati del profilo (nome, biografia, foto)</li>
                <li>Informazioni sui pet (nome, specie, età, foto)</li>
                <li>Contenuti pubblicati (post, foto, video, commenti)</li>
                <li>Dati di comunicazione (messaggi, chiamate)</li>
              </ul>

              <h3 className="text-xl font-semibold text-primary mb-3">3.2 Dati raccolti automaticamente</h3>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Dati di utilizzo (pagine visitate, funzioni utilizzate)</li>
                <li>Informazioni del dispositivo (tipo, sistema operativo, browser)</li>
                <li>Dati di localizzazione (se autorizzati)</li>
                <li>Cookie e tecnologie simili</li>
                <li>Indirizzo IP e dati di connessione</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">4. Finalità del Trattamento</h2>
              <div className="space-y-4">
                <div className="bg-white/5 p-4 rounded-lg">
                  <h4 className="font-semibold text-primary mb-2">Esecuzione del contratto:</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Fornitura dei servizi della piattaforma</li>
                    <li>Gestione dell'account utente</li>
                    <li>Abilitazione delle funzionalità social</li>
                  </ul>
                </div>

                <div className="bg-white/5 p-4 rounded-lg">
                  <h4 className="font-semibold text-primary mb-2">Interesse legittimo:</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Miglioramento dei servizi</li>
                    <li>Sicurezza della piattaforma</li>
                    <li>Prevenzione frodi e abusi</li>
                    <li>Analisi statistiche anonimizzate</li>
                  </ul>
                </div>

                <div className="bg-white/5 p-4 rounded-lg">
                  <h4 className="font-semibold text-primary mb-2">Consenso:</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Marketing diretto</li>
                    <li>Profilazione per contenuti personalizzati</li>
                    <li>Geolocalizzazione</li>
                    <li>Cookie non essenziali</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">5. Condivisione dei Dati</h2>
              <p className="leading-relaxed mb-4">I tuoi dati possono essere condivisi con:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Fornitori di servizi:</strong> hosting, analitiche, supporto tecnico</li>
                <li><strong>Autorità competenti:</strong> quando richiesto dalla legge</li>
                <li><strong>Altri utenti:</strong> contenuti pubblici secondo le tue impostazioni privacy</li>
                <li><strong>Partner commerciali:</strong> solo con il tuo consenso esplicito</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">6. Trasferimenti Internazionali</h2>
              <p className="leading-relaxed">
                I tuoi dati potrebbero essere trasferiti in paesi terzi. Utilizziamo misure di sicurezza 
                appropriate come clausole contrattuali standard approvate dalla Commissione Europea.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">7. Conservazione dei Dati</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Dati dell'account:</strong> fino alla cancellazione dell'account</li>
                <li><strong>Contenuti:</strong> fino alla rimozione da parte dell'utente</li>
                <li><strong>Dati di sicurezza:</strong> 12 mesi dopo l'ultima attività</li>
                <li><strong>Dati di fatturazione:</strong> secondo gli obblighi fiscali (10 anni)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">8. I Tuoi Diritti</h2>
              <p className="leading-relaxed mb-4">Secondo il GDPR, hai diritto a:</p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white/5 p-4 rounded-lg">
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Accesso ai tuoi dati</li>
                    <li>Rettifica di dati inesatti</li>
                    <li>Cancellazione ("diritto all'oblio")</li>
                    <li>Limitazione del trattamento</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-lg">
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Portabilità dei dati</li>
                    <li>Opposizione al trattamento</li>
                    <li>Revoca del consenso</li>
                    <li>Reclamo al Garante Privacy</li>
                  </ul>
                </div>
              </div>
              <p className="leading-relaxed mt-4">
                Per esercitare i tuoi diritti, contatta: privacy@astropet.com
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">9. Sicurezza</h2>
              <p className="leading-relaxed mb-4">Implementiamo misure di sicurezza tecniche e organizzative:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Crittografia dei dati in transito e a riposo</li>
                <li>Autenticazione a due fattori</li>
                <li>Controlli di accesso rigorosi</li>
                <li>Monitoraggio delle attività sospette</li>
                <li>Backup regolari e procedure di disaster recovery</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">10. Minori</h2>
              <p className="leading-relaxed">
                Il servizio è rivolto a utenti con almeno 13 anni. Per utenti tra 13 e 16 anni è richiesto 
                il consenso dei genitori. Non raccogliamo consapevolmente dati di bambini sotto i 13 anni.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">11. Cookie Policy</h2>
              <p className="leading-relaxed">
                Utilizziamo cookie e tecnologie simili come descritto nella nostra 
                <Link to="/cookie-policy" className="text-primary hover:underline"> Cookie Policy</Link>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">12. Modifiche alla Privacy Policy</h2>
              <p className="leading-relaxed">
                Ci riserviamo il diritto di aggiornare questa Privacy Policy. Le modifiche sostanziali 
                saranno comunicate tramite email o notifica in-app almeno 30 giorni prima dell'entrata in vigore.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">13. Contatti DPO</h2>
              <div className="bg-white/5 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Data Protection Officer:</strong><br/>
                  Email: dpo@astropet.com<br/>
                  Indirizzo: [Indirizzo DPO]
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">14. Autorità di Controllo</h2>
              <div className="bg-white/5 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Garante per la Protezione dei Dati Personali</strong><br/>
                  Piazza di Monte Citorio, 121 - 00186 Roma<br/>
                  Tel: +39 06 69677 1<br/>
                  Fax: +39 06 69677 3785<br/>
                  Email: garante@gpdp.it<br/>
                  Web: www.garanteprivacy.it
                </p>
              </div>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;